/**
 * DataGrid state components - thin wrappers over shared UI.
 * Loading, empty, and error states use shared loading/empty/error components.
 */

import React from 'react';
import { cn } from '@/lib/utils';
import { PanelLoading } from '@/components/ui/loading';
import { EmptyState } from '@/components/ui/empty';
import { ErrorState } from '@/components/ui/error';

interface DataGridStateProps {
  className?: string;
}

export const DataGridLoading: React.FC<DataGridStateProps & { message?: string }> = ({
  className,
  message = 'Loading...',
}) => (
  <PanelLoading
    message={message}
    className={cn('min-h-full flex items-center justify-center', className)}
  />
);

export const DataGridEmpty: React.FC<DataGridStateProps & { message?: string }> = ({
  className,
  message = 'No data',
}) => (
  <EmptyState
    description={message}
    className={cn('min-h-full flex items-center justify-center', className)}
  />
);

export const DataGridError: React.FC<
  DataGridStateProps & { message: string; onRetry?: () => void }
> = ({ className, message, onRetry }) => (
  <ErrorState
    title="Error"
    description={message}
    onRetry={onRetry}
    className={cn('min-h-full flex items-center justify-center', className)}
  />
);
